import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "comenzi-container" }
const _hoisted_2 = { class: "filters-bar" }
const _hoisted_3 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_4 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_5 = {
  key: 0,
  class: "no-orders"
}
const _hoisted_6 = {
  key: 1,
  class: "subtabs-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "subtab-header"
}
const _hoisted_8 = { class: "tab-content" }

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxButton from "devextreme-vue/button";
import FiltreComenzi from "./FilterComenzi.vue";
import GridComenzi from "./GridComenzi.vue";
import GridComandaDetalii from "./GridComandaDetalii.vue";

interface Filter {
  category: number | null;
  start: string;
  end: string;
}

// Interfață ASUMATĂ a întregului obiect de date (folosită de GridComenzi)
interface OrderData {
  Id: string | number; // Putem avea si number, in functie de DB
  Cod: string;
  Nume: string;
  DataComenzii: string;
  ValoareComanda: number;
  [key: string]: any; // Permite orice alte câmpuri
}

// Interfață pentru un tab deschis (păstrează doar metadatele necesare tab-ului)
interface OpenOrderTab {
  id: string;
  orderId: string;
  title: string;
  // Putem adăuga și alte metadate relevante pentru UI, de exemplu:
  // clientName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PRO_ComenziView',
  setup(__props) {

const route = useRoute();

const filters = ref<Filter>({ category: null, start: "", end: "" });

const mainTabs = [
  { id: "comenzi", title: "Comenzi" },
  { id: "detalii", title: "Detalii Comenzi" },
];

const activeMainTab = ref(0);
const openOrders = ref<OpenOrderTab[]>([]);
const activeSubTab = ref(0);
let uniqueTabCounter = 0;

/**
 * Actualizează filtrele și șterge toate sub-taburile deschise.
 */
function updateFilters(newFilters: Filter) {
  filters.value = newFilters;

  // Șterge taburile deschise
  openOrders.value = [];
  activeSubTab.value = 0;
  activeMainTab.value = 0;
}

function onMainTabChanged(e: any) {
  activeMainTab.value = e.component.option("selectedIndex");
}

function onSubTabChanged(e: any) {
  activeSubTab.value = e.component.option("selectedIndex");
}

/**
 * Deschide o comandă nouă într-un sub-tab separat.
 * Acum primește întregul obiect de comandă (OrderData).
 */
function openOrder(order: OrderData) {
  const comandaIdString = String(order.Id);

  // Verifică dacă tab-ul este deja deschis pentru a evita duplicatele
  const existingIndex = openOrders.value.findIndex(t => t.orderId === comandaIdString);
  if (existingIndex !== -1) {
    activeSubTab.value = existingIndex;
    activeMainTab.value = 1;
    return;
  }

  uniqueTabCounter++;

  const newTab: OpenOrderTab = {
    id: `tab-${comandaIdString}-${uniqueTabCounter}`,
    orderId: comandaIdString,
    // Folosim Codul și Numele Clientului pentru titlul tabului
    title: `${order.Cod}`,
  };

  // Folosim Deep Copy pentru a forța DevExtreme să re-randareze
  const updatedOrders = [...openOrders.value, newTab];
  openOrders.value = updatedOrders;

  activeSubTab.value = openOrders.value.length - 1;

  activeMainTab.value = 1;
}

/**
 * Închide un sub-tab (fără a folosi evenimentul, doar indexul).
 */
function closeSubTab(index: number) {
  // Folosim Deep Copy pentru a forța DevExtreme să actualizeze
  const updatedOrders = openOrders.value.value.filter((_, i) => i !== index);
  openOrders.value = updatedOrders;

  if (activeSubTab.value >= openOrders.value.length) {
    activeSubTab.value = openOrders.value.length - 1;
  }

  if (openOrders.value.length === 0) {
    activeMainTab.value = 0;
  }
}

// LOGICĂ PENTRU DESCHIDEREA AUTOMATĂ DIN RUTĂ
onMounted(() => {
  const comandaIdFromRoute = route.params.comandaId as string;

  if (comandaIdFromRoute) {
    // Aici trebuie să reconstruim un obiect 'OrderData' minim necesar 
    // pentru a apela openOrder, deoarece din rută avem doar ID-ul.
    // Presupunem un Cod și Nume generic, sau ar trebui să se facă un fetch de date.
    const minimalOrderData: OrderData = { 
        Id: comandaIdFromRoute, 
        Cod: comandaIdFromRoute,
        Nume: "Încărcare...",
        DataComenzii: "",
        ValoareComanda: 0,
    };
    openOrder(minimalOrderData);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FiltreComenzi, { onFiltersChanged: updateFilters })
    ]),
    _createVNode(_unref(DxTabPanel), {
      "selected-index": activeMainTab.value,
      "data-source": mainTabs,
      "animation-enabled": false,
      loop: false,
      "swipe-enabled": false,
      onSelectionChanged: onMainTabChanged,
      height: "100%"
    }, {
      item: _withCtx(({ data }) => [
        (data.id === 'comenzi')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(GridComenzi, {
                filters: filters.value,
                onOpenOrder: openOrder,
                class: "GridComenzi"
              }, null, 8, ["filters"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (openOrders.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nicio comandă deschisă. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(DxTabPanel), {
                      "selected-index": activeSubTab.value,
                      "data-source": openOrders.value,
                      "animation-enabled": false,
                      loop: false,
                      "swipe-enabled": false,
                      onSelectionChanged: onSubTabChanged,
                      height: "100%",
                      class: "subtabs-panel"
                    }, {
                      title: _withCtx(({ data, index }) => [
                        (data && data.title)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("span", null, _toDisplayString(data.title), 1),
                              _createVNode(_unref(DxButton), {
                                icon: "close",
                                text: "",
                                "styling-mode": "text",
                                onClick: () => closeSubTab(index)
                              }, null, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      item: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(), _createBlock(GridComandaDetalii, {
                            key: data.orderId,
                            comandaId: data.orderId,
                            class: "GridComandaDetalii"
                          }, null, 8, ["comandaId"]))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["selected-index", "data-source"])
                  ]))
            ]))
      ]),
      _: 1
    }, 8, ["selected-index"])
  ]))
}
}

})